import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transportationTag } from './api-tags/transportation-tags';
import { inspectionTags } from './api-tags/inspection-tags';
import { shippingTags } from './api-tags/shipping-tags';
import { carriersTags } from './api-tags/carriers-tags';
import { paymentTags } from './api-tags/payment-tags';
import { creditTags } from './api-tags/credits-tags';
import { customerTags } from './api-tags/customer-tags';
import { auctionTags } from './api-tags/auction-tags';
import { taskTags } from './api-tags/task-tags';
import { settingTags } from './api-tags/setting-tags';
import { marketingTags } from './api-tags/marketing-tags';

// initialize an empty api service that we'll inject endpoints into later as needed
export const globalApiService = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: () => ({}),
  keepUnusedDataFor: 300,
  tagTypes: [
    ...carriersTags,
    ...transportationTag,
    ...inspectionTags,
    ...shippingTags,
    ...paymentTags,
    ...creditTags,
    ...customerTags,
    ...auctionTags,
    ...taskTags,
    ...settingTags,
    ...marketingTags,
  ],
});
